import { render, staticRenderFns } from "./SundrySupplierDetailsTabs.vue?vue&type=template&id=11159fcc&"
import script from "./SundrySupplierDetailsTabs.vue?vue&type=script&lang=js&"
export * from "./SundrySupplierDetailsTabs.vue?vue&type=script&lang=js&"
import style0 from "./SundrySupplierDetailsTabs.vue?vue&type=style&index=0&id=11159fcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports